import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";

import { Card, Icon, Input, Menu, Message, Segment } from "semantic-ui-react";
import appRoutes, { dashboardRoutes } from "constants/routeConstants";
import ProductCard from "components/features/ProductCard";

import Alerts from "utilities/Alerts";
import http from "utilities/http";

function Products() {
	const [productList, setProductList] = useState([]);
	const [filteredProductList, setFilteredProductList] = useState([]);
	const [search, setSearch] = useState("");
	const history = useHistory();

	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		http.get("/products")
			.then((response) => {
				const { products } = response.data;

				setProductList(products);
			})
			.catch((ex) => Alerts.httpException(ex))
			.finally(() => setLoading(false));
	}, []);
	useEffect(() => {
		if (search) {
			const filteredProducts = productList.filter(
				(item) =>
					item.name.toLowerCase().search(search.toLowerCase()) > -1 ||
					item.localName.toLowerCase().search(search.toLowerCase()) >
						-1
			);
			setFilteredProductList(filteredProducts);
		} else setFilteredProductList(productList);
	}, [search, productList]);

	return (
		<>
			<Menu
				borderless
				style={{
					position: "sticky",
					top: "0",
					zIndex: 99,
					background: "white",
				}}
			>
				<Menu.Menu>
					<Menu.Item
						as="h3"
						style={{
							fontWeight: "600",
							marginBottom: 0,
							paddingRight: "10px",
						}}
					>
						Products
					</Menu.Item>
					<Menu.Item style={{ padding: 0 }}>
						<Icon
							link
							circular
							bordered
							onClick={() =>
								history.push(
									appRoutes.DASHBOARD +
										dashboardRoutes.ADDPRODUCTS
								)
							}
							name="plus"
						/>
					</Menu.Item>
				</Menu.Menu>
				<Menu.Menu position="right">
					<Menu.Item>
						<Input
							icon="search"
							value={search}
							onChange={(e) => setSearch(e.target.value)}
							placeholder="Search..."
						/>
					</Menu.Item>
				</Menu.Menu>
			</Menu>
			<Segment loading={loading} basic>
				{!productList.length ? (
					<Message>No record found.</Message>
				) : (
					<Card.Group itemsPerRow={3}>
						{filteredProductList.map((item) => (
							<ProductCard key={item._id} product={item} />
						))}
					</Card.Group>
				)}
			</Segment>
		</>
	);
}

export default Products;
